export default __webpack_public_path__ + "static/media/avatar-recommendation_club_bot.325d282a.png";